/* eslint-disable react-refresh/only-export-components */
import { createContext, useContext, type ReactNode } from 'react';
import { useNotifications } from '@/hooks/useNotifications';
import type { NotificationItem } from '@/api/notifications';

interface NotificationContextValue {
  notifications: NotificationItem[];
  unreadCount: number;
  connected: boolean;
  toast: NotificationItem | null;
  soundEnabled: boolean;
  setSoundEnabled: (enabled: boolean) => void;
  markAsRead: (id: string) => Promise<void>;
  markAllAsRead: () => Promise<void>;
  dismissToast: () => void;
}

const NotificationContext = createContext<NotificationContextValue | null>(null);

export function NotificationProvider({ children }: { children: ReactNode }) {
  const value = useNotifications();
  return <NotificationContext.Provider value={value}>{children}</NotificationContext.Provider>;
}

export function useNotificationContext(): NotificationContextValue {
  const ctx = useContext(NotificationContext);
  if (!ctx) {
    // Return a noop context for unauthenticated routes
    return {
      notifications: [],
      unreadCount: 0,
      connected: false,
      toast: null,
      soundEnabled: true,
      setSoundEnabled: () => {},
      markAsRead: async () => {},
      markAllAsRead: async () => {},
      dismissToast: () => {},
    };
  }
  return ctx;
}
